import { Component } from '@angular/core';

@Component({
  selector: 'app-chat-typing',
  template: `
    <div class="xc-typing">
      <span></span><span></span><span></span>
    </div>
  `,
  styles: [`
    .xc-typing {
      display: inline-flex; align-items: center; gap: 5px; padding: 4px 2px;
    }
    .xc-typing span {
      width: 7px; height: 7px; border-radius: 50%;
      background: var(--xc-accent, #4f7ef7);
      animation: xcBounce 1.3s infinite ease-in-out;
    }
    .xc-typing span:nth-child(1) { animation-delay: 0s; }
    .xc-typing span:nth-child(2) { animation-delay: 0.22s; }
    .xc-typing span:nth-child(3) { animation-delay: 0.44s; }

    @keyframes xcBounce {
      0%, 80%, 100% { transform: scale(0.55); opacity: 0.4; }
      40%           { transform: scale(1.0);  opacity: 1; }
    }
  `]
})
export class ChatTypingComponent {}
